<template>

  <t-dialog
      v-model:visible="visible"
      header="重置密码"
      width="400"
      @confirm="submit"
  >

    <t-form>

      <t-form-item label="新密码">

        <t-input v-model="password" type="password"/>

      </t-form-item>

    </t-form>

  </t-dialog>

</template>

<script setup>

import { ref,watch } from 'vue'
import { resetPasswordApi } from '@/api/user'
import {DialogPlugin, MessagePlugin} from 'tdesign-vue-next'
import md5 from "md5";

const props=defineProps({
  visible:Boolean,
  user:Object
})

const emit=defineEmits(['update:visible'])

const visible=ref(false)
const password=ref('')

watch(()=>props.visible,(v)=>{
  if (v) {
    password.value = generateSecureCode(12)
  }
  visible.value=v
})

watch(visible,(v)=>{
  emit('update:visible',v)
})

const submit=()=>{
  resetPasswordApi({
    uid:props.user.id,
    password:md5(password.value)
  }).then((res)=>{

    if (res.data.code == 200) {
      MessagePlugin.success("密码重置成功")

      visible.value=false

      // 弹框提示账号密码
      const dialog = DialogPlugin.alert({
        header: '密码重置成功',
        body: ` 密码：${password.value}`,
        confirmBtn: '我知道了',
        onConfirm: () => {
          dialog.hide()
        }
      })

      emit('success')
    } else {
      MessagePlugin.warning(res.data.msg)
    }
  })
}

function generateSecureCode(length = 8) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const array = new Uint32Array(length)
  window.crypto.getRandomValues(array)

  return Array.from(array)
      .map(x => chars[x % chars.length])
      .join('')
}


</script>